document.addEventListener('DOMContentLoaded', function () {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); } });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  const vids = document.querySelectorAll('.showcase-item video');
  const vio = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const v = entry.target;
      if (entry.isIntersecting) { v.play().catch(() => {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.4 });
  vids.forEach(v => vio.observe(v));
});

/* ============================================================
   SHOPIFY CHECKOUT — Cart Permalinks (simplest approach).

   Clicking "Add to Cart" builds a direct link to Shopify's own
   cart/checkout endpoints and navigates there immediately — no
   API calls, no waiting, no separate "review cart" step on this
   site. The customer lands on Shopify's real checkout with the
   right item(s), quantity, and (if selected) subscription plan
   already applied.

   Two link shapes, depending on whether a subscription is picked:

   ONE-TIME purchase → simple comma-path permalink:
     https://{shop}.myshopify.com/cart/{variantId}:{qty}[,{variantId2}:{qty2}]
     (Shopify's documented cart permalink format)

   SUBSCRIBE (selling plan) → GET-based /cart/add, wrapped in a
   cart/clear so each click starts from a clean cart:
     https://{shop}.myshopify.com/cart/clear?return_to=
       %2Fcart%2Fadd%3Fitems...%26selling_plan%3D...%26return_to%3D%2Fcheckout
   (the plain comma-path format has no selling_plan support, so
   subscriptions need this fuller /cart/add form instead)
   ============================================================ */
const SHOPIFY_DOMAIN = 'qnya2e-hk.myshopify.com';

/**
 * Build a Shopify checkout permalink for one or more line items.
 * @param {Array<{variantId: string|number, quantity: number, sellingPlanId?: string|number}>} items
 * @returns {string} full URL that adds the item(s) and lands on Shopify checkout
 */
function buildCheckoutPermalink(items) {
  const anyPlan = items.some(i => i.sellingPlanId);

  if (!anyPlan) {
    // Simple, documented format — no selling plan involved.
    const pairs = items.map(i => `${i.variantId}:${i.quantity}`).join(',');
    return `https://${SHOPIFY_DOMAIN}/cart/${pairs}`;
  }

  // At least one line needs a selling plan — use the fuller /cart/add form.
  const parts = [];
  items.forEach(i => {
    parts.push(`items[][id]=${i.variantId}`);
    parts.push(`items[][quantity]=${i.quantity}`);
    if (i.sellingPlanId) { parts.push(`items[][selling_plan]=${i.sellingPlanId}`); }
  });
  const addQuery = parts.join('&') + '&return_to=/checkout';
  const addUrl = `/cart/add?${addQuery}`;
  return `https://${SHOPIFY_DOMAIN}/cart/clear?return_to=${encodeURIComponent(addUrl)}`;
}

const PRICES = {
  hair:   { onetime: 69,    subscribe: 58.65 },
  face:   { onetime: 69.90, subscribe: 59.42 },
  bundle: { onetime: 109,   subscribe: 92 }
};

function selectToggle(groupId, el, mode) {
  const group = document.getElementById(groupId);
  group.querySelectorAll('.toggle-option').forEach(o => o.classList.remove('active'));
  el.classList.add('active');
  group.dataset.mode = mode;

  if (groupId === 'hair-toggle') { updatePriceDisplay('hair'); }
  if (groupId === 'face-toggle') { updatePriceDisplay('face'); }
  if (groupId === 'bundle-toggle') {
    document.getElementById('bundle-price-display').textContent = '$' + PRICES.bundle[mode];
    document.getElementById('bundle-save-display').textContent =
      mode === 'subscribe' ? 'You save $46.90 vs. buying separately, every month' : 'You save $29.90 vs. buying separately';
  }
}

const QTY_MIN = 1;
const QTY_MAX = 10;

// These are NOT invented numbers — they're the exact flat-dollar amounts
// of the real "Ritual Duo Bundle" automatic discounts already live in
// Shopify. That discount is scoped to any 2 units of Hair Serum + Face
// Serum combined, so buying 2 of the SAME product already qualifies —
// confirmed live via /cart/add.js on 2026-08-19. Keep these in sync with
// the actual discount amounts in Shopify Admin → Discounts if they change.
const BUNDLE_DISCOUNT_ONETIME = 29.90;
const BUNDLE_DISCOUNT_SUBSCRIBE = 26.07;

/**
 * Refreshes the per-unit price and the "buy 2, get the bundle discount"
 * note for a product card, based on its current purchase mode. Always
 * visible (not just after the customer bumps quantity) so it acts as
 * an upfront incentive to buy two instead of one.
 */
function updatePriceDisplay(productKey) {
  const toggleEl = document.getElementById(productKey + '-toggle');
  const mode = toggleEl ? (toggleEl.dataset.mode || 'subscribe') : 'subscribe';
  const unit = PRICES[productKey][mode];

  const priceEl = document.getElementById(productKey + '-price-display');
  if (priceEl) { priceEl.textContent = '$' + unit.toFixed(2).replace(/\.00$/, ''); }

  const noteEl = document.getElementById(productKey + '-qty-note');
  if (!noteEl) return;
  const savings = mode === 'subscribe' ? BUNDLE_DISCOUNT_SUBSCRIBE : BUNDLE_DISCOUNT_ONETIME;
  noteEl.textContent = 'Buy 2, get the Ritual Duo Bundle discount — save $' + savings.toFixed(2);
  noteEl.style.display = 'block';
}

document.addEventListener('DOMContentLoaded', function () {
  updatePriceDisplay('hair');
  updatePriceDisplay('face');
});

/**
 * Increment/decrement the quantity shown next to a product's
 * Add to Cart button, clamped to [QTY_MIN, QTY_MAX].
 */
function changeQty(productKey, delta) {
  const el = document.getElementById(productKey + '-qty-value');
  if (!el) return;
  const current = parseInt(el.textContent, 10) || QTY_MIN;
  const next = Math.min(QTY_MAX, Math.max(QTY_MIN, current + delta));
  el.textContent = next;
  updatePriceDisplay(productKey);
}

/**
 * Add-to-cart button handler for a single product card.
 * Reads the selected purchase mode (one-time vs subscribe) and
 * quantity from that card's controls, builds the matching
 * permalink, and sends the customer straight to Shopify checkout.
 */
function addToShopifyCart(productKey, variantIdNumeric, sellingPlanIdNumeric, toggleGroupId, btnEl) {
  const toggleEl = document.getElementById(toggleGroupId);
  const mode = toggleEl ? (toggleEl.dataset.mode || 'subscribe') : 'subscribe';

  const qtyEl = document.getElementById(productKey + '-qty-value');
  const quantity = qtyEl ? (parseInt(qtyEl.textContent, 10) || QTY_MIN) : QTY_MIN;

  const item = { variantId: variantIdNumeric, quantity: quantity };
  if (mode === 'subscribe') { item.sellingPlanId = sellingPlanIdNumeric; }

  const url = buildCheckoutPermalink([item]);
  console.debug('[Vivaroot] Checkout link for', productKey, '(' + mode + '):', url);

  if (btnEl) { btnEl.textContent = 'Redirecting…'; btnEl.disabled = true; }
  window.location.href = url;
}

/**
 * Add-to-cart handler for the Ritual Duo bundle — both products,
 * same purchase mode, same permalink, same redirect.
 */
function addBundleToCart() {
  const toggleEl = document.getElementById('bundle-toggle');
  const mode = toggleEl ? (toggleEl.dataset.mode || 'subscribe') : 'subscribe';

  const items = [
    { variantId: 45943820517459, quantity: 1, sellingPlanId: mode === 'subscribe' ? 5303795795 : undefined }, // hair serum
    { variantId: 45943820582995, quantity: 1, sellingPlanId: mode === 'subscribe' ? 5303828563 : undefined }  // face serum
  ];

  const url = buildCheckoutPermalink(items);
  console.debug('[Vivaroot] Checkout link for bundle (' + mode + '):', url);

  window.location.href = url;
}

/* The header still has a cart icon in its original design. Since permalink
   clicks redirect the browser away immediately, there's no client-side cart
   state left to preview on this site — the drawer will honestly show "empty"
   if opened, which is accurate (nothing is ever added without redirecting).
   Kept only so the existing icon doesn't throw an error if clicked. */
function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
  if (overlay) { overlay.classList.add('open'); }
  document.body.style.overflow = 'hidden';
}
function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
  if (overlay) { overlay.classList.remove('open'); }
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') { closeCartDrawer(); }
});
